import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import CouponDailySpendDataGrid from 'components/reports/vouchers/CouponDailySpendDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import {
  convertQueryParamsIntoObject,
  convertObjectIntoQueryParams,
  convertToUnix,
  convertFromUnix,
} from 'constant/Helpers';
import cloneDeep from 'lodash/cloneDeep';
// url
import { getCouponDailySpendReportPageUrl } from 'constant/AppUrls';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
// api
import CouponReportService from 'services/reportsService/CouponReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const CouponDailySpendPage = () => {
  const [data, setData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: convertToUnix(),
    toDate: convertToUnix(),
    datetype: 0,
    catid: -1,
  });
  const [voucherCatList, setVoucherCatList] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await CouponReportService.getAllCouponDailySpend(params);
      const updatedList = res.data.map((item, index) => ({
        ...item,
        serial: index + 1,
      }));
      setData(updatedList);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Coupon Daily Spend Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  const fetchVoucherCategoryList = async () => {
    try {
      const res = await CouponReportService.getVoucherCategoryList();
      setVoucherCatList(res.data);
    } catch (err) {
      errorLogger('Coupon Daily Spend Report Page Fetch Voucher Category List Error:', err);
      toast.error('Failed to fetch voucher category list!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
    } else {
      fetchData(inputValues);
    }
    fetchVoucherCategoryList();
  }, []);

  const handleSubmit = async () => {
    const updatedParams = cloneDeep(inputValues);
    updatedParams.fromDate = convertFromUnix(inputValues.fromDate);
    updatedParams.toDate = convertFromUnix(inputValues.toDate);
    const queryString = convertObjectIntoQueryParams(updatedParams);
    navigate({
      pathname: getCouponDailySpendReportPageUrl(),
      search: queryString,
    });
    fetchData(updatedParams);
  };

  const handleExport = async () => {
    try {
      const updatedParams = cloneDeep(inputValues);
      updatedParams.fromDate = convertFromUnix(inputValues.fromDate);
      updatedParams.toDate = convertFromUnix(inputValues.toDate);
      const res = await CouponReportService.exportAllCouponDailySpendReport(updatedParams);
      toast.success(res?.data?.message);
    } catch (err) {
      errorLogger('Coupon Daily Spend Report Page Export Data Error:', err);
      toast.error('Failed to export excel file!!');
    }
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        productType
        voucherCategory
        voucherCatList={voucherCatList}
        hasExport
        handleExport={handleExport}
        title="Coupon Daily Spend"
      />
      <CouponDailySpendDataGrid data={data} />
    </div>
  );
};

export default CouponDailySpendPage;
